module.exports = __webpack_public_path__ + "img/tr-car-overlap-icon.68ddedf9.svg";